import axios from 'axios'
import { BASE_URL } from '../../constants/config'


async function listPospal(token) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            skip: 0,
            limit: 0,

        },
        url: `${BASE_URL}/pospal`,
    }
    return axios(options)
}

async function getPospalUser(pospalId, user, token) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/shop/${pospalId}/${user}`,
    }
    return axios(options)
}

async function createPospalUser(pospalId, token, categoryName, number, name, point, discount, balance, phone, email, shopperUserId) {
    const options = {
        method: 'post',
        url: `${BASE_URL}/pospal/${pospalId}/member`,
        headers: {
            'Authorization': `JWT ${token}`
        },
        data: {
            categoryName, number, name, point, discount, balance, phone, email, shopperUserId
        }
    }
    return axios(options)
}

async function editPospalUser(pospalId, id, token, customerUid, categoryName, name, discount, phone, email, enable, shopperUserId) {
    const options = {
        method: 'put',
        url: `${BASE_URL}/pospal/${pospalId}/member/${id}`,
        headers: {
            'Authorization': `JWT ${token}`
        },
        data: {
            customerUid, categoryName, name, discount, phone, email, enable, shopperUserId
        }
    }
    return axios(options)
}

async function listCustomerCategory(pospalId, token) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/pospal/${pospalId}/customerCategory`,
    }
    return axios(options)
}

async function listPospalUsers(pospalId, token, skip, shop, name, email, phone) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            skip: skip,
            limit: 0,
            shop: shop,
            name: name,
            email: email,
            phone: phone
        },
        url: `${BASE_URL}/pospal/${pospalId}/member`,
    }
    return axios(options)
}

export default {
    listPospal,
    getPospalUser,
    createPospalUser,
    editPospalUser,
    listCustomerCategory,
    listPospalUsers
}